import { render, staticRenderFns } from "./fctop.vue?vue&type=template&id=3f6a45be&scoped=true&"
import script from "./fctop.vue?vue&type=script&lang=js&"
export * from "./fctop.vue?vue&type=script&lang=js&"
import style0 from "./fctop.vue?vue&type=style&index=0&id=3f6a45be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6a45be",
  null
  
)

export default component.exports